var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 26C9.52758 26 6.26295 24.6478 3.80758 22.1924C1.3522 19.737 0 16.4724 0 13C0 9.52758 1.35225 6.263 3.80758 3.80758C6.2629 1.35215 9.52758 0 13 0C16.4724 0 19.737 1.3522 22.1924 3.80758C24.6478 6.26295 26 9.52758 26 13C26 16.4724 24.6477 19.737 22.1924 22.1924C19.7371 24.6478 16.4724 26 13 26ZM13 1.625C6.7278 1.625 1.625 6.7278 1.625 13C1.625 19.2722 6.7278 24.375 13 24.375C19.2722 24.375 24.375 19.2722 24.375 13C24.375 6.7278 19.2722 1.625 13 1.625Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 12.1875C11.88 12.1875 10.9688 11.2763 10.9688 10.1562C10.9688 9.03622 11.88 8.125 13 8.125C14.12 8.125 15.0312 9.03622 15.0312 10.1562C15.0312 10.605 15.395 10.9688 15.8438 10.9688C16.2925 10.9688 16.6562 10.605 16.6562 10.1562C16.6562 8.41948 15.4386 6.96272 13.8125 6.59212V5.6875C13.8125 5.2388 13.4488 4.875 13 4.875C12.5512 4.875 12.1875 5.2388 12.1875 5.6875V6.59212C10.5614 6.96272 9.34375 8.41948 9.34375 10.1562C9.34375 12.1723 10.9839 13.8125 13 13.8125C14.12 13.8125 15.0312 14.7237 15.0312 15.8438C15.0312 16.9638 14.12 17.875 13 17.875C11.88 17.875 10.9688 16.9638 10.9688 15.8438C10.9688 15.395 10.605 15.0312 10.1562 15.0312C9.7075 15.0312 9.34375 15.395 9.34375 15.8438C9.34375 17.5805 10.5614 19.0373 12.1875 19.4079V20.3125C12.1875 20.7612 12.5512 21.125 13 21.125C13.4488 21.125 13.8125 20.7612 13.8125 20.3125V19.4079C15.4386 19.0373 16.6562 17.5805 16.6562 15.8438C16.6562 13.8277 15.0161 12.1875 13 12.1875Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.ffc8ccce969a4e461fea9c87efbac50d.svg";
export { ForwardRef as ReactComponent };